import { useEffect, useState, useRef } from 'react';
import { useSynapse } from 'app/lib/synaptik';
import { WidgetStates, PaymentWidgetReturnType, PaymentWidgetProps, BankCard } from './types';

export const usePaymentWidget = (props: PaymentWidgetProps): PaymentWidgetReturnType => {
  const [fetchPaymentMethods, paymentMethods] = useSynapse(({ user }) => [
    user.fetchPaymentMethods,
    user.state.paymentMethods,
  ]);

  const [paymentState, setPaymentState] = useState<WidgetStates>(WidgetStates.FETCHING);
  const [activePaymentToken, setActivePaymentToken] = useState<string>();

  const paymentFormRef = useRef<{
    generateCardToken: () => Promise<string | undefined>;
  }>();

  useEffect(() => {
    let mounted = true;
    fetchPaymentMethods().then(
      (methods: BankCard[]) =>
        mounted &&
        setPaymentState(
          methods?.length ? WidgetStates.LIST : props.isCheckout ? WidgetStates.FORM : WidgetStates.EMPTY_LIST
        )
    );

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const defaultPaymentMethodToken = paymentMethods.find((pm: BankCard) => pm.isDefault)?.token;

    setActivePaymentToken(defaultPaymentMethodToken);
  }, [paymentState, paymentMethods]);

  const generateCardToken = async () => paymentFormRef.current?.generateCardToken() || activePaymentToken;

  const handleTokenReceived = (token: string) => {
    if (props.isCheckout) {
      setActivePaymentToken(token);
    }
  };

  return {
    ...props,
    paymentState,
    setPaymentState,
    paymentFormRef,
    paymentMethods,
    generateCardToken,
    activePaymentToken,
    onTokenReceived: handleTokenReceived,
  };
};
